import SkeletonStack from '@/components/shared/loader/skeleton-stack';

const MonitorButtonLoader = () => {
  return <SkeletonStack count={2} className="min-w-20 grow h-9 rounded-sm" />;
};

export default MonitorButtonLoader;
